import { render, staticRenderFns } from "./UploadFileForm.vue?vue&type=template&id=3d4ffd82&scoped=true&"
import script from "./UploadFileForm.vue?vue&type=script&lang=ts&setup=true&"
export * from "./UploadFileForm.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./UploadFileForm.vue?vue&type=style&index=0&id=3d4ffd82&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d4ffd82",
  null
  
)

export default component.exports